import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c577e674"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "legend-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.lineInfos, (line, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "line-info-row",
        key: index
      }, [
        _createVNode($setup["LineTurnPathLegendLineStyle"], {
          lineIndex: index,
          color: 
          $props.linePathColorInfos[index % $props.linePathColorInfos.length]?.color ?? '#000'
        
        }, null, 8 /* PROPS */, ["lineIndex", "color"]),
        _createVNode($setup["LineTypeChip"], {
          lineTypeCode: line.lineTypeCode,
          lineTypeName: line.lineTypeName,
          isSmallSize: true
        }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName"]),
        _createElementVNode("span", null, _toDisplayString($setup.useGetLineRouteName(line.lineTypeCode, line.routeName, line.lineNum)), 1 /* TEXT */)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}